import React, { useEffect, useRef, useState } from "react";
import { useForm } from "react-hook-form";
import { useOutletContext } from "react-router-dom";
import toastr from "../../../utils/toast";
import axios from "axios";
import AddContacts from "./AddContacts";

function MeetingForm({ onClose, company_id }) {
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
    getValues,
    watch,
    setValue,
  } = useForm();

  const meeting_date = watch("meeting_date");
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const { setGlobalLoading, token } = useOutletContext();
  const [meetingData, setMeetingData] = useState({});
  const [queue_check, setQueueCheck] = useState(0);
  const [Contacts, setContacts] = useState([]);
  const [is_recurring, setIsRecurring] = useState(0);
  const [ContactsAddForm, setContactsAddForm] = useState(false);

  async function getContacts() {
    try {
      setGlobalLoading(true);
      const response = await axios.get(
        `${API_BASE_URL}/companyinfo/get_contacts/${company_id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );
      setContacts(response.data.contacts);
    } catch (error) {
      setGlobalLoading(false);
      toastr.error(error);
    } finally {
      setGlobalLoading(false);
    }
  }

  const AddedContacts = useRef(false);

  useEffect(() => {
    if (AddedContacts.current) return;
    AddedContacts.current = true;
    getContacts();
  }, []);

  const onSubmit = async (data) => {
    setGlobalLoading(true);
    try {
      const response = await axios.post(
        `${API_BASE_URL}/companyinfo/schedule_meeting/${company_id}`,
        { data: data },
        {
          headers: { Authorization: `Bearer ${token}` },
        },
      );
      toastr.success(response.data.message);
      onClose();
    } catch (error) {
      console.log(error);
      setGlobalLoading(false);
      toastr.error(error);
    } finally {
      setGlobalLoading(false);
    }
  };

  async function getMeetingRecords(contact_id) {
    try {
      setGlobalLoading(true);
      const response = await axios.get(
        `${API_BASE_URL}/companyinfo/get_meeting_records/${company_id}/${contact_id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );
      console.log(response.data);
      const meeting_data = response.data.meeting_data;
      const meetings = response.data.check_relation;
      const queue_check = response.data.queue_check;
      const frequency = response.data.frequency;
      const is_recurring = response.data.is_recurring || 0;

      setMeetingData(meeting_data);
      setQueueCheck(queue_check);
      if (meetings?.meeting_date) {
        const date = new Date(meetings.meeting_date);
        date.setDate(date.getDate() + 1); // add 1 day
        const formattedDate = date.toISOString().split("T")[0];
        setValue("meeting_date", formattedDate);
      }
      if (frequency) {
        setValue("frequency", frequency);
      }

      setValue("is_recurring", is_recurring);
      setIsRecurring(is_recurring);
    } catch (error) {
      console.log(error);
      setGlobalLoading(false);
      toastr.error(error);
    } finally {
      setGlobalLoading(false);
    }
  }
  return (
    <>
      {ContactsAddForm && (
        <AddContacts
          onClose={() => {
            setContactsAddForm(false);
          }}
          company_id={company_id}
        />
      )}

      <div className="modal fade show d-block" tabIndex="-1" role="dialog">
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Schedule Meeting</h5>
              <button
                type="button"
                className="btn-close"
                onClick={onClose}
                aria-label="Close"
              ></button>
            </div>
            <form onSubmit={handleSubmit(onSubmit)}>
              <div className="modal-body">
                <div className="mb-3">
                  <label className="form-label">
                    Contact Met With / To be met with
                    <span className="text-danger ms-2">*</span>
                  </label>
                  <select
                    className={`form-select ${
                      errors?.contact_met_with ? "is-invalid" : ""
                    }`}
                    {...register("contact_met_with", { required: true })}
                    onChange={async (e) => {
                      if (e.target.value === "add_contact") {
                        setContactsAddForm(true);
                        return;
                      }
                      if (e.target.value === "") return;
                      await getMeetingRecords(e.target.value);
                    }}
                  >
                    <option value="">Select</option>
                    {Contacts.length > 0 ? (
                      <>
                        {Contacts.map((contact) => (
                          <option key={contact.id} value={contact.id}>
                            {contact.firstname + " " + contact.lastname}
                          </option>
                        ))}
                      </>
                    ) : (
                      <option value={"add_contact"} className="text-danger">
                        No contacts found! Click To Add
                      </option>
                    )}
                  </select>
                </div>
                <div className="mb-3">
                  <label className="form-label">
                    Meeting Date
                    <span className="text-danger ms-2">*</span>
                  </label>
                  <input
                    type="date"
                    {...register("meeting_date", { required: true })}
                    className={`form-control ${
                      errors?.meeting_date ? "is-invalid" : ""
                    }`}
                  />
                </div>
                {meeting_date &&
                  meeting_date <= new Date().toISOString().split("T")[0] && (
                    <>
                      <div className="mb-3">
                        <label className="form-label">
                          Status
                          <span className="text-danger ms-2">*</span>
                        </label>
                        <select
                          className={`form-select ${
                            errors?.status ? "is-invalid" : ""
                          }`}
                          {...register("status", { required: true })}
                        >
                          <option value="">Select</option>
                          <option value="scheduled">Scheduled</option>
                          <option value="completed">Completed</option>
                          <option value="cancelled">Cancelled</option>
                          <option value="missed">Missed</option>
                        </select>
                      </div>
                      <div className="mb-3">
                        <label className="form-label">Notes</label>
                        <textarea
                          className="form-control"
                          {...register("notes")}
                        ></textarea>
                      </div>
                    </>
                  )}
                {!meetingData && (
                  <div className="mb-3">
                    <label className="form-label">
                      Next Meeting Date
                      {is_recurring === 1 && (
                        <span className="text-danger ms-2">* </span>
                      )}
                      {errors?.next_meeting_date && (
                        <span className="text-danger ms-2">
                          {errors?.next_meeting_date.message}
                        </span>
                      )}
                    </label>
                    <input
                      type="date"
                      {...register("next_meeting_date", {
                        required:
                          is_recurring === 1
                            ? "Next Meeting Date is required."
                            : false,
                        validate: (value) => {
                          // Skip validation if no value
                          if (!value) return true;

                          // Next meeting must be greater than meeting date
                          if (new Date(value) <= new Date(meeting_date)) {
                            return "Next Meeting Date must be greater than Meeting Date.";
                          }

                          return true;
                        },
                      })}
                      className={`form-control ${
                        errors?.next_meeting_date ? "is-invalid" : ""
                      }`}
                    />
                  </div>
                )}

                <div className="d-flex mb-3">
                  <label className="form-label me-3">Recurring Meeting</label>
                  <input
                    type="checkbox"
                    className="mt-1"
                    checked={is_recurring === 1 ? true : false}
                    onChange={(e) => {
                      if (e.target.checked) {
                        setValue("is_recurring", 1);
                        setValue("frequency", "");
                        setIsRecurring(1);
                      } else {
                        setValue("is_recurring", 0);
                        setIsRecurring(0);
                        setValue("frequency", "");
                      }
                    }}
                  />
                </div>
                {is_recurring === 1 && (
                  <>
                    <div className="mb-3">
                      <label className="form-label">Meeting Frequency</label>
                      <select
                        className={`form-select ${
                          errors?.frequency ? "is-invalid" : ""
                        }`}
                        {...register("frequency", {
                          required: is_recurring === 1 ? 1 : 0,
                        })}
                      >
                        <option value="">Select</option>
                        <option value="weekly">Weekly</option>
                        <option value="monthly">Monthly</option>
                        <option value="half_yearly">Half Yearly</option>
                        <option value="yearly">Yearly</option>
                      </select>
                    </div>
                  </>
                )}
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary me-sm-3"
                  onClick={onClose}
                >
                  Close
                </button>
                <button
                  type="submit"
                  disabled={Contacts.length === 0}
                  className="btn btn-primary"
                >
                  Submit
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
}

export default MeetingForm;
